import React from 'react';
import { Minus, Plus } from 'lucide-react';

export default function ScalingSlider({ servings, onChange, min = 1, max = 20 }) {
  const btn = 'w-8 h-8 rounded-lg flex items-center justify-center bg-gray-100 dark:bg-night-card text-gray-700 dark:text-night-text hover:bg-gray-200 dark:hover:bg-night-surface disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <div className="inline-flex items-center gap-3" role="group" aria-label="Adjust servings">
      <button onClick={() => onChange(Math.max(min, servings - 1))} disabled={servings <= min} aria-label="Decrease servings" className={btn}>
        <Minus size={16} />
      </button>
      <div className="flex flex-col items-center min-w-[64px]">
        <span className="text-xl font-semibold text-gray-900 dark:text-night-text leading-none">{servings}</span>
        <span className="text-[11px] text-gray-500 dark:text-night-muted uppercase tracking-wide">servings</span>
      </div>
      <button onClick={() => onChange(Math.min(max, servings + 1))} disabled={servings >= max} aria-label="Increase servings" className={btn}>
        <Plus size={16} />
      </button>
    </div>
  );
}
